var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{staticClass:"custom-sm-modal",attrs:{"id":"translate-modal","title":"Translate site","hide-backdrop":"","scrollable":"","hide-footer":""}},[_c('CGTranslator',{attrs:{"countries":_vm.countries},on:{"click":_vm.hideModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }